import { render, staticRenderFns } from "./LoadingSkeleton.vue?vue&type=template&id=09dce7e0&scoped=true&"
import script from "./LoadingSkeleton.vue?vue&type=script&lang=js&"
export * from "./LoadingSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./LoadingSkeleton.vue?vue&type=style&index=0&id=09dce7e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09dce7e0",
  null
  
)

export default component.exports